<template>
  <Modal
    id="EmployeeEntryRecordEdit"
    width="80%"
    :visible="visible"
    @cancel="visible = !visible"
    @ok="submit"
    :title="title"
  >
    <Row align="middle" justify="center">
      <Col span="18" class="content">
        <Row>
          <Col span="24">
            <Form
              ref="employeeEntryRecordForm"
              :model="form"
              layout="vertical"
              :rules="validateRules"
            >
              <Row justify="space-around">
                <Col span="10">
                    <FormItem :label="$t('employeeEntryRecord.field.id_emp')" name="idEmp">
                      <!--关联表的下拉选择-->
                      <Select
                      disabled
                              v-model:value="form.idEmp"
                              :placeholder="$t('employeeEntryRecord.validate.required.id_emp')"
                              :dropdownStyle="{ zIndex: 9999999950 }"
                      >
                          <SelectOption :key="sk" v-for="(item,sk) in selectList['employeeList']" :value="item['idEmp']">{{ item['nickName'] }}</SelectOption>
                      </Select>
                  </FormItem>
                </Col>
                <Col span="10">
                    <FormItem :label="$t('employeeEntryRecord.field.entry_date')" name="entryDate">
                      <!-- <Input :placeholder="$t('employeeEntryRecord.validate.required.entry_date')"
                             v-model:value="form.entryDate">
                      </Input> -->
                      <DatePicker valueFormat="YYYY-MM-DD" v-model:value="form.entryDate" :popupStyle="{ zIndex: 9999999950 }"></DatePicker>
                  </FormItem>
                </Col>
                <Col span="10">
                    <FormItem :label="$t('employeeEntryRecord.field.term_date')" name="termDate">
                      <!-- <Input :placeholder="$t('employeeEntryRecord.validate.required.term_date')"
                             v-model:value="form.termDate">
                      </Input> -->
                      <DatePicker valueFormat="YYYY-MM-DD" v-model:value="form.termDate" :popupStyle="{ zIndex: 9999999950 }"></DatePicker>
                  </FormItem>
                </Col>
                <Col span="10">
                    <FormItem :label="$t('employeeEntryRecord.field.term_remark')" name="termRemark">
                      <Textarea
                              v-model:value="form.termRemark"
                              :placeholder="$t('employeeEntryRecord.validate.required.term_remark')"
                              :auto-size="{ minRows: 5, maxRows: 10 }"
                              showCount
                      />
                  </FormItem>
                </Col>
              </Row>
            </Form>
          </Col>
        </Row>
      </Col>
    </Row>
  </Modal>
</template>

<script>
import {
  Modal,
  Row,
  Col,
  Form,
  Input,
  InputNumber,
  Image,
  Radio,
  Steps,
  Step,
  Button,
  message,
  Select,
  DatePicker,
  InputGroup,
  Upload,
  Descriptions,
  DescriptionsItem,
} from "ant-design-vue";
import {
  UploadOutlined,
  UserOutlined,
  SolutionOutlined,
  FileImageOutlined,
  CheckOutlined,
  PlusOutlined,
} from "@ant-design/icons-vue";
import { EmployeeEntryRecordAdd } from "@/api/EmployeeEntryRecordAdd";
import { EmployeeEntryRecordEdit } from "@/api/EmployeeEntryRecordEdit";
import { EmployeeListAll } from "@/api/EmployeeListAll"


export default {
  name: "EmployeeEntryRecordEdit",
  components: {
    Modal,
    Row,
    Col,
    UserOutlined,
    SolutionOutlined,
    FileImageOutlined,
    CheckOutlined,
    UploadOutlined,
    PlusOutlined,
    Form: Form,
    FormItem: Form.Item,
    Input: Input,
    InputPassword: Input.Password,
    Textarea:Input.TextArea,
    InputGroup,
    InputNumber,
    Image,
    RadioGroup: Radio.Group,
    RadioButton: Radio.Button,
    Steps,
    Step,
    Button,
    message,
    Select,
    SelectOption: Select.Option,
    DatePicker,
    Upload,
    Descriptions,
    DescriptionsItem,
  },
  data() {
    return {
      visible: false,
      actionType: "",
      form: {
        idEmpEntRec : "",
        idEmp : "",
        entryDate : "",
        termDate : "",
        termRemark : ""
      },
      fileList: {
      },
      selectList: {
        employeeList: [],
      },
      validateRules: {
        idEmpEntRec: [
          {
            required: true,
            message: this.$t("employeeEntryRecord.validate.required.id_emp_ent_rec"),
            trigger: "change",
            type: "number",
          },
        ],
        idEmp: [
          {
            required: true,
            message: this.$t("employeeEntryRecord.validate.required.id_emp"),
            trigger: "change",
            type: "number",
          },
        ],
        entryDate: [
          {
            required: false,
            message: this.$t("employeeEntryRecord.validate.required.entry_date"),
            trigger: "change",
          },
        ],
        termDate: [
          {
            required: false,
            message: this.$t("employeeEntryRecord.validate.required.term_date"),
            trigger: "change",
          },
        ],
        termRemark: [
          {
            required: false,
            message: this.$t("employeeEntryRecord.validate.required.term_remark"),
            trigger: "change",
          },
        ],
      },
    };
  },
  computed: {
    title: function () {
      let name = "";
      switch (this.actionType) {
        case "add":
          name = this.$t("public.name.add");
          break;
        case "edit":
          name = this.$t("public.name.edit");
          break;
      }
      return name;
    },
  },
  methods: {
    addShow() {
      this.actionType = "add";
      this._resetData();
      this.getEmployeeList();
      this.visible = true;
    },
    async editShow(obj) {
      this._resetData();
      this.actionType = "edit";
      this.form = JSON.parse(JSON.stringify(obj));
      this.getEmployeeList();
      this.visible = true;
    },
    submit() {
      this.$refs["employeeEntryRecordForm"]
        .validate()
        .then(() => {
          let api;
          switch (this.actionType) {
            case "add":
              console.log("add");
              api = new EmployeeEntryRecordAdd();
              break;
            case "edit":
              console.log("edit");
              api = new EmployeeEntryRecordEdit();
              break;
            default:
              return false;
          }
          api.post(this.form).then((response, any) => {
            if (0 == parseInt(response.data.code)) {
              message.success(response.data.msg);
              this.$emit("updateList");
              this.visible = false;
            } else {
              message.error(response.data.msg);
            }
          });
        })
        .catch(() => {
        });
    },
    getEmployeeList() {
      const api = new EmployeeListAll();
      api.get().then((response) => {
        if (0 == parseInt(response.data.code)) {
            this.selectList.employeeList = response.data.data;
        } else {
            message.error(response.data.msg);
        }
      });
    },
    // reset data
    _resetData() {
      this.form = {
        idEmpEntRec : "",
        idEmp : "",
        entryDate : "",
        termDate : "",
        termRemark : "",
      };
    },
  },
};
</script>

<style lang="less">
</style>